export default __webpack_public_path__ + "static/media/user-avatar-1.aac17726.png";